// extracted by mini-css-extract-plugin
export default {"consentMessage":"YourPhoneNumber_consentMessage__H1dQ8","skeletonLoadingAnimation":"YourPhoneNumber_skeletonLoadingAnimation__OPAsF"};